<template>
    <b-container fluid >
    <div id="inicio" class="row justify-content-md-center m-auto">

    <div class="col-sm-9 fondo">
        <b-card class="mt-4 details">
            <b-row>    
                <div class="col-md-3 text-center">
                <b-col >
                    Fecha Vigencia
                    <h6>{{this.FechaV}}</h6>
                </b-col>
                </div>
                <div class="col-md-3 text-center">
                <b-col>
                    Costo Suscripción
                    <h6>${{this.costoSus}}</h6>
                </b-col>
                </div>
                <div class="col-md-3 text-center">
                <b-col>
                    Depósito Suscripción
                    <h6>${{formatPrice(this.deposito)}}</h6>
                </b-col>
                </div>
                <div class="col-md-3 text-center">
                <b-col>
                    Total a Pagar.
                    <h6>${{this.valorTotal}} </h6>
                </b-col>
                </div>
            </b-row>
            <b-row>
                <div v-for="auto in autos" :key="auto.id" id="header" class="text-center mt-3">
                <b-col> Vehículo: <h6>{{ auto.modelYear }} {{ auto.brandDescription }} {{ auto.trimDesciption }}, {{ auto.bodyType }} {{ auto.gearboxType }}, {{ auto.doors}} PUERTAS </h6></b-col>
                <b-col style="font-size: 12px;"> Recoge la unidad en <h6 style="font-size: 12px;">{{ auto.dealerShip }} </h6>, de la misma forma la unidad se tiene que entregar en <h6 style="font-size: 12px;">{{ auto.dealerShip }} </h6>.</b-col>
                </div>
            </b-row>
        </b-card>

        <b-card border-variant="light" class="mt-3">
            <b-form @submit="onSubmit" @reset="onReset" v-if="show">
            <b-row >
                <div class="col-md-4">
                <b-col>
                    <b-form-group id="input-group-1"  class="text-left" label-for="input-1">
                        <h6>Nombre(s):</h6>
                    <b-form-input id="input-1" type="text" v-model="formaData.Nombre" placeholder="Nombre(s)"  maxlength="26" required autofocus></b-form-input>
                        <!-- <p>{{this.formaData.Nombre.replace(/á/gi,"a").replace(/é/gi,"e").replace(/í/gi,"i").replace(/ó/gi,"o").replace(/ú/gi,"u")}}</p> -->
                    </b-form-group>
                </b-col>
                </div>
                <div class="col-md-4">
                <b-col>
                    <b-form-group id="input-group-2" class="text-left" label-for="input-3">
                        <h6>Primer Apellido:</h6>
                    <b-form-input id="input-2"  v-model="formaData.ApellidoPaterno" placeholder="Primer Apellido" maxlength="26" required></b-form-input>
                    </b-form-group>
                </b-col>
                </div>
                <div class="col-md-4">
                <b-col>
                    <b-form-group id="input-group-3"  class="text-left" label-for="input-3">
                        <h6>Segundo Apellido:</h6>
                    <b-form-input id="input-3"  v-model="formaData.ApellidoMaterno" placeholder="Segundo Apellido" maxlength="26" required ></b-form-input>
                    </b-form-group>
                </b-col>
                </div>
            </b-row>
            <b-row class="mt-2">
                <div class="col-md-6">
                <b-col>
                    <b-form-group id="input-group-5" label-for="input-5" class="text-left">
                        <h6>Email:</h6>
                        <b-form-input id="input-5"  v-model="formaData.Email" type="email" placeholder="Ingresa tu email" required ></b-form-input>
                    </b-form-group>
                </b-col>
                </div>
                <div class="col-md-6">
                <b-col>
                    <b-form-group id="input-group-6" class="text-left" label-for="input-6">
                        <h6>Teléfono:</h6>
                    <b-form-input id="input-6"  v-model="formaData.Telefono" type="text" onkeypress="return (event.charCode == 8 || event.charCode == 0 || event.charCode == 13) ? null : event.charCode >= 48 && event.charCode <= 57" placeholder="Número de Teléfono" maxlength="10" required ></b-form-input>
                    </b-form-group>
                </b-col>
                </div>
            </b-row>

            <b-row class="mt-2">
                <div class="col-md-4">
                <b-col>
                    <b-form-group id="input-group-7" class="text-left" label-for="input-7">
                        <h6>Código Postal:</h6>
                    <b-form-input id="input-7"  v-model="formaData.Domicilio.CodigoPostal" placeholder="Código Postal" onkeypress="return (event.charCode == 8 || event.charCode == 0 || event.charCode == 13) ? null : event.charCode >= 48 && event.charCode <= 57" maxlength="5" required ></b-form-input>
                    </b-form-group>
                </b-col>
                </div>
                <div class="col-md-4">
                <b-col>
                    <b-form-group id="input-group-8" label-for="input-8" class="text-left">
                        <h6>Estado:</h6>
                        <b-form-input id="input-8"  v-model="formaData.Domicilio.Estado" placeholder="Estado" maxlength="40" required ></b-form-input>
                    </b-form-group>
                </b-col>
                </div>

                <div class="col-md-4">
                <b-col>
                    <b-form-group id="input-group-9" class="text-left" label-for="input-9">
                        <h6>Ciudad:</h6>
                    <b-form-input id="input-9" type="text" v-model="Ciudad" placeholder="Ciudad" maxlength="40" required ></b-form-input>
                    </b-form-group>
                </b-col>
                </div>
            </b-row>

            <b-row class="mt-2">
                <div class="col-md-6">
                <b-col>
                    <b-form-group id="input-group-10" class="text-left" label-for="input-10">
                        <h6>Fecha de Nacimiento:</h6>
                        <b-form-input type="date"  v-model="formaData.FechaNacimiento" required ></b-form-input>
                    </b-form-group>
                </b-col>
                </div>
                <div class="col-md-6">
                    <b-col>
                        <b-form-group id="input-group-11" class="text-left" label-for="input-11">
                            <h6>Régimen Fiscal:</h6>
                                <b-form-select id="input-11" v-model="formaData.TipoPersona" :options="regimen" class="mb-2 selectF" required></b-form-select>
                        </b-form-group>
                    </b-col>
                </div>
            </b-row>

            <b-row class="mt-2" >
                <div class="col-md-6">
                <b-col>
                    <b-form-group id="input-group-12" class="text-left" label-for="input-12">
                        <h6>RFC:</h6>
                    <b-form-input id="input-12"  v-model="formaData.RFC" placeholder="RFC" maxlength="13" required ></b-form-input>
                        <b-form-text id="input-live-help">Tu RFC debe ser a 13 dígitos.</b-form-text>
                    </b-form-group>
                </b-col>
                </div>
            </b-row>
            <div class="col-md-12"><hr></div>

            <b-row >
                <div class="col-md-6">
                <b-col>
                    <b-form-group id="input-group-13" class="text-left" label-for="input-13">
                        <h6>Calle:</h6>
                    <b-form-input id="input-13"  v-model="formaData.Domicilio.Calle" placeholder="" maxlength="40" required ></b-form-input>
                    </b-form-group>
                </b-col>
                </div>
                <div class="col-md-3">
                <b-col>
                    <b-form-group id="input-group-14" label-for="input-14" class="text-left">
                        <h6>Número Exterior:</h6>
                        <b-form-input id="input-14"  v-model="formaData.Domicilio.NumExterior" type="text" onkeypress="return (event.charCode == 8 || event.charCode == 0 || event.charCode == 13) ? null : event.charCode >= 48 && event.charCode <= 57" maxlength="5" placeholder="" required></b-form-input>
                    </b-form-group>
                </b-col>
                </div>
                <div class="col-md-3">
                <b-col>
                    <b-form-group id="input-group-15" class="text-left" label-for="input-15">
                        <h6>Número Interior:</h6>
                    <b-form-input id="input-15"  v-model="formaData.Domicilio.NumInterior" type="text" onkeypress="return (event.charCode == 8 || event.charCode == 0 || event.charCode == 13) ? null : event.charCode >= 48 && event.charCode <= 57" maxlength="5" placeholder=""  ></b-form-input>
                    </b-form-group>
                </b-col>
                </div>
            </b-row>
            <b-row class="mt-2">
                <div class="col-md-6">
                <b-col>
                    <b-form-group id="input-group-16" class="text-left" label-for="input-16">
                        <h6>Colonia o Población:</h6>
                    <b-form-input id="input-16"  v-model="formaData.Domicilio.Colonia" placeholder="" maxlength="40" required ></b-form-input>
                    </b-form-group>
                </b-col>
                </div>
                <div class="col-md-6">
                <b-col>
                    <b-form-group id="input-group-17" class="text-left" label-for="input-17">
                        <h6>Delegación o Municipio:</h6>
                    <b-form-input id="input-17"  v-model="formaData.Domicilio.Municipio" placeholder="" maxlength="40" required ></b-form-input>
                    </b-form-group>
                </b-col>
                </div>
            </b-row>
            <b-row class="mt-2">
                <div class="col-md-6">
                <b-col>
                    <b-img src="../assets/important.png" style="width: 30px; height:auto;" alt=""></b-img> 
                    <span class="h6E"> Todos los campos son obligatorios.</span>
                </b-col>
                </div>
                <div class="col-md-2">
                <b-col>
                    <b-button @click.prevent="onReset()" class="button_ca">CANCELAR</b-button>
                </b-col>
                </div>
                <div class="col-md-3">
                <b-col>
                     <b-button type="submit" class="button_sc">SOLICITAR SUSCRIPCIÓN</b-button>
                     <!-- <b-button @click.prevent="cotizar()" class="button_sc">SOLICITAR SUSCRIPCION</b-button> -->
                </b-col>
                </div>
            </b-row>
            </b-form>
                <b-card class="mt-3" header="JSON">
                <pre class="m-0">{{ formaData }}</pre>
                </b-card>
        </b-card>
    </div>
    </div>
    </b-container>

</template>

<script>
  export default {
      name: "Formulario",

    data() {
      return {
          dealer:'',
          autos: [],
          FechaV: sessionStorage.getItem("fechaVigencia"),
          tags: sessionStorage.getItem("Tags"),
          costoSus: sessionStorage.getItem("valorTotal"),
          valorTotal: sessionStorage.getItem("valorSuscripcion"),
          deposito: 2400,
          formaData: {
            Uuid: this.uuidv4(),
            Nombre: '',
            ApellidoPaterno: '',
            ApellidoMaterno: '',
            FechaNacimiento: '',
            Email: '',
            Telefono: '',
            RFC: '',
            TipoPersona: '',
            Tramite: 1,
            UnidadNegocio: 4,
            Agencia: 'Clickauto Mobility',
            Domicilio: {
                Calle: '',
                NumInterior: '',
                NumExterior: '',
                Colonia: '',
                CodigoPostal: '',
                Estado: '',
                Municipio: '',
            },
            Vehiculo: {
                Marca: '',
                Inventario: '',
                Modelo: '',
                Year: '',
                Version: '',
                NumeroSerie: sessionStorage.getItem("vinUnidad"),
                Vigencia: sessionStorage.getItem("fechaVigencia"),
                //Vigencia: '2022-03-01',
                Modalidad: sessionStorage.getItem("modalidadNegocio"),
                Cuota: sessionStorage.getItem("valorSuscripcion"),
                Plazo: sessionStorage.getItem("TipoSuscripcion")
            }
          },
        Ciudad: '',
        show: true,
        regimen: [
          { value: 1, text: 'Persona Física' },
          { value: 2, text: 'Persona Física con Actividad Empresarial' },
          { value: 3, text: 'Persona Física Extranjera' }
        ],
      }
    },

    methods: {
        onSubmit(event) {
            event.preventDefault();
            this.tokenLatin();
        },

        onReset(event) {
            window.history.go(-1);
        },

        cotizar(){
            this.enviaMail();
            this.$router.push({ path: '/correoCortas'});
        },

        tokenMail(){
            let user = {username: "soportedigital@clikauto.com", password: "Desarrollo123$"};
            axios.post("https://qasrv-notificaciones.autocom.mx/api/token/login", user)
            .then((response) => {
            //console.log("token stock-->", response.data.token);
            sessionStorage.setItem("mailToken", response.data.token);
            });
        },

        enviaMail(){
        let mail = {
            user:"noreply@clikautomobility.com",
            aplication:"Suscripciones",
            subject:"ClikAutoMobility Continuar solicitud de Suscripción",
            EmailsTo: [{email:this.formaData.Email}],
            EmailsToCc: [{emailCc:"soportedigital@clikauto.com"},
            {emailCc:"rosa.velia@autocom.mx"},
            {emailCc:"atencionmobility@clikautomobility.com"},
            {emailCc:"soportedigital@clikautomobility.com"}],
            body:`
                    <!DOCTYPE HTML PUBLIC "-//W3C//DTD HTML 4.01 Transitional//EN" "http://www.w3.org/TR/html4/loose.dtd">
                    <html>
                    <head>
                    <meta http-equiv="Content-Type" content="text/html; charset=utf-8">
                    <!-- utf-8 works for most cases -->
                    <meta name="viewport" content="width=device-width">
                    <!-- Forcing initial-scale shouldn't be necessary -->
                    <meta http-equiv="X-UA-Compatible" content="IE=edge">
                    <!-- Use the latest (edge) version of IE rendering engine -->
                    <title>clikautomibility_suscripcion</title>
                    <!-- The title tag shows in email notifications, like Android 4.4. -->

                    <!-- Please use an inliner tool to convert all CSS to inline as inpage or external CSS is removed by email clients -->
                    <!-- important in CSS is used to prevent the styles of currently inline CSS from overriding the ones mentioned in media queries when corresponding screen sizes are encountered -->

                    <!-- CSS Reset -->
                    <style type="text/css">
                    /* What it does: Remove spaces around the email design added by some email clients. */
                        /* Beware: It can remove the padding / margin and add a background color to the compose a reply window. */
                    html, body {
                        margin: 0 !important;
                        padding: 0 !important;
                        height: 100% !important;
                        width: 100% !important;
                    }
                    /* What it does: Stops email clients resizing small text. */
                    * {
                        -ms-text-size-adjust: 100%;
                        -webkit-text-size-adjust: 100%;
                    }
                    /* What it does: Forces Outlook.com to display emails full width. */
                    .ExternalClass {
                        width: 100%;
                    }
                    /* What is does: Centers email on Android 4.4 */
                    div[style*="margin: 16px 0"] {
                        margin: 0 !important;
                    }
                    /* What it does: Stops Outlook from adding extra spacing to tables. */
                    table, td {
                        mso-table-lspace: 0pt !important;
                        mso-table-rspace: 0pt !important;
                    }
                    /* What it does: Fixes webkit padding issue. Fix for Yahoo mail table alignment bug. Applies table-layout to the first 2 tables then removes for anything nested deeper. */
                    table {
                        border-spacing: 0 !important;
                        border-collapse: collapse !important;
                        table-layout: fixed !important;
                        margin: 0 auto !important;
                    }
                    table table table {
                        table-layout: auto;
                    }
                    /* What it does: Uses a better rendering method when resizing images in IE. */
                    img {
                        -ms-interpolation-mode: bicubic;
                    }
                    /* What it does: Overrides styles added when Yahoo's auto-senses a link. */
                    .yshortcuts a {
                        border-bottom: none !important;
                    }
                    /* What it does: Another work-around for iOS meddling in triggered links. */
                    a[x-apple-data-detectors] {
                        color: inherit !important;
                    }
                    </style>

                    <!-- Progressive Enhancements -->
                    <style type="text/css">
                    /* What it does: Hover styles for buttons */
                    .button-td, .button-a {
                        transition: all 100ms ease-in;
                    }

                    .button-td:hover, .button-a:hover {
                        background: #172546 !important;
                        border-color: #172546 !important;
                    }

                    /* Media Queries */
                    @media screen and (max-width: 480px) {
                    /* What it does: Forces elements to resize to the full width of their container. Useful for resizing images beyond their max-width. */
                    .fluid, .fluid-centered {
                        width: 100% !important;
                        max-width: 100% !important;
                        height: auto !important;
                        margin-left: auto !important;
                        margin-right: auto !important;
                    }
                    /* And center justify these ones. */
                    .fluid-centered {
                        margin-left: auto !important;
                        margin-right: auto !important;
                    }
                    /* What it does: Forces table cells into full-width rows. */
                    .stack-column, .stack-column-center {
                        display: block !important;
                        width: 100% !important;
                        max-width: 100% !important;
                        direction: ltr !important;
                    }
                    /* And center justify these ones. */
                    .stack-column-center {
                        text-align: center !important;
                    }
                    /* What it does: Generic utility class for centering. Useful for images, buttons, and nested tables. */
                    .center-on-narrow {
                        text-align: center !important;
                        display: block !important;
                        margin-left: auto !important;
                        margin-right: auto !important;
                        float: none !important;
                    }
                    table.center-on-narrow {
                        display: inline-block !important;
                    }
                    }
                    </style>
                    </head>
                    <body width="100%" bgcolor="#e0e0e0" style="margin: 0;" yahoo="yahoo">
                    <table cellpadding="0" cellspacing="0" border="0" height="100%" width="100%" bgcolor="#e0e0e0" style="border-collapse:collapse;">
                    <tr>
                        <td><center style="width: 100%;">
                            
                            <!-- Visually Hidden Preheader Text : BEGIN -->
                            <div style="display:none;font-size:1px;line-height:1px;max-height:0px;max-width:0px;opacity:0;overflow:hidden;mso-hide:all;font-family: sans-serif;"> ¡Tenemos tus resultados!</div>
                            <!-- Visually Hidden Preheader Text : END -->
                            
                            <div style="max-width: 680px;"> 
                            <!--[if (gte mso 9)|(IE)]>
                                <table cellspacing="0" cellpadding="0" border="0" width="680" align="center">
                                <tr>
                                <td>
                                <![endif]--> 
                            
                            <!-- Email Header : BEGIN -->
                            <table cellspacing="0" cellpadding="0" border="0" align="center" width="100%" style="max-width: 680px;">
                                <tr>
                                <td style="padding: 40px 0; text-align: center; background-color: #172546;"><img src="https://qa-suscripciones.autocom.mx/img/clikautomobility_logo.f34456fd.png" width="250" alt="CLICKAUTO" border="0"  ></td>
                                </tr>
                            </table>
                            <!-- Email Header : END --> 
                            
                            <!-- Email Body : BEGIN -->
                            <table cellspacing="0" cellpadding="0" border="0" align="center" bgcolor="#ffffff" width="100%" style="max-width: 680px;">
                                
                            <!-- 1 Column Text : BEGIN -->
                                <tr>
                                <td><table cellspacing="0" cellpadding="0" border="0" width="100%">
                                    <tr>
                                        <td style="padding: 40px; text-align: center; font-family: sans-serif; font-size: 15px; mso-height-rule: exactly; line-height: 20px; color: #555555;"> 
                                        <h1 style="font-size:25px;margin:0 0 20px 0;text-align: center;font-family:Open Sans,sans-serif;">¡HOLA ${this.formaData.Nombre} ${this.formaData.ApellidoPaterno} ${this.formaData.ApellidoMaterno} !</h1>
                                        <h1 style="font-size:25px;margin:0 0 20px 0;text-align: center;font-family:Open Sans,sans-serif;">¡Tenemos tus resultados!</h1>
                                        <p style="margin:0 0 15px 0;font-size:14px;line-height: 22.52px;text-align: center;font-family:Open Sans,sans-serif;">Tienes una solicitud de suscripción pendiente,
                                            continúa desde un dispositivo móvil.</p>
                                    </tr>
                                    </table></td>
                                </tr>
                                

                    <!-- Two Even Columns : BEGIN -->
                    <tr>
                    <td bgcolor="#fff" align="center" height="100%" valign="top" width="100%"><!--[if mso]>
                                <table border="0" cellspacing="0" cellpadding="0" align="center" width="1920">
                                <tr>
                                <td align="center" valign="top" width="1920">
                                <![endif]-->
                        
                        <table border="0" cellpadding="0" cellspacing="0" align="center" width="100%" style="max-width:660px;">
                        <tr>

                            <td style="padding:30px;background:#f2f2f2;">
                                <table role="presentation" style="width:100%;border-collapse:collapse;border:0;border-spacing:0;font-size:10px;font-family:Open Sans,sans-serif;">
                                <tr>
                                    <td style="padding:0;width:33%;" align="center">
                                    <p style="margin:0;font-size:10px;line-height:15.01px;font-family:Open Sans,sans-serif;color:#000000;">
                                        Suscripción desde.<br/>
                                    </p>
                                    <p style="margin:0; font-size: 25px; line-height: 37.53px;font-weight: bold; font-family: Open Sans, sans-serif; color: #172546;">
                                        $${this.valorTotal}
                                    </p>
                                    </td>
                                    <td style="padding:0;width:33%;" align="center">
                                    <p style="margin:0;font-size:10px;line-height:15.01px;font-family:Open Sans,sans-serif;color:#000000;">
                                        Vigencia de Suscripción.<br/>
                                    </p>
                                    <p style="margin:0; font-size: 25px; line-height: 37.53px;font-weight: bold; font-family: Open Sans, sans-serif; color: #172546;">
                                            ${this.FechaV}
                                    </p>
                                    </td>
                                    <td style="padding:0;width:33%;" align="center">
                                    <p style="margin:0;font-size:10px;line-height:15.01px;font-family:Open Sans,sans-serif;color:#000000;">
                                        Entidad Emplacamiento.<br/>
                                    </p>
                                    <p style="margin:0; font-size: 18px; line-height: 37.53px;font-weight: bold; font-family: Open Sans, sans-serif; color: #172546;">
                                        ${this.valorEntidad}
                                    </p>
                                    </td>
                                </tr>
                                </table>
                            </td>
                            </tr>

                            <td align="center" valign="top" style="font-size:0; padding: 10px 0;">
                            <!--[if mso]>
                                            </td>
                                            <td align="left" valign="top" width="330">
                                            <![endif]-->

                                            <div style="display:inline-block; max-width:50%; background-color: #f2f2f2; margin: 0 -2px; min-width:200px; vertical-align:top; width:100%;" class="stack-column">
                                                <table cellspacing="0" cellpadding="0" border="0" width="100%">
                                                    <tr>
                                                    <td style="padding: 10px 10px;"><table cellspacing="0" cellpadding="0" border="0" width="100%" style="font-size: 14px;text-align: left;">
                                                        <tr>
                                                        <td style="padding:0;width:33%;" align="center">
                                                            <p style="margin:0;font-size:10px;line-height:15.01px;font-family:Open Sans,sans-serif;color:#000000;">
                                                            Vehiculo:<br/>
                                                            </p>
                                                            <p style="margin:0; font-size: 20px; line-height: 37.53px;font-weight: bold; font-family: 'Times New Roman', Times, serif; color: #172546;">
                                                                ${this.formaData.Vehiculo.Marca} ${this.formaData.Vehiculo.Modelo} ${this.formaData.Vehiculo.Year} ${this.formaData.Vehiculo.Version}
                                                            </p>
                                                        </td>
                                                        </tr>
                                                        </table></td>
                                                    </tr>
                                                </table>
                                                </div>
                        
                            <!--[if mso]>
                                            </td>
                                            </tr>
                                            </table>
                                            <![endif]--></td>
                        </tr>
                        </table>
                        
                        <!--[if mso]>
                                </td>
                                </tr>
                                </table>
                                <![endif]--></td>
                    </tr>
                    <!-- Two Even Columns : END --> 



                                        <!-- 1 Column Text : BEGIN -->
                                        <tr>
                                            <td><table cellspacing="0" cellpadding="0" border="0" width="100%">
                                                <tr>
                                                <td style="padding: 40px; text-align: center; font-family: sans-serif; font-size: 15px; mso-height-rule: exactly; line-height: 20px; color: #555555;"> 
                                                    <p style="margin:0 0 15px 0;font-size:14px;line-height: 22.52px;text-align: center;font-family:Open Sans,sans-serif;">¡Termina ahora tu solicitud y estrena ya el auto de tus sueños!</p>
                                                    
                                                    <!-- Button : Begin -->
                                                    
                                                    <table cellspacing="0" cellpadding="0" border="0" align="center" style="margin: auto">
                                                    <tr>
                                                        <td style="border-radius: 3px; background: #51AED3; width: 300px; height: 50px;text-align: center;" class="button-td"><a href="https://onboarding-dev.latinid-cloud.com.mx/MobilityWeb/#/resume/applicant/${sessionStorage.getItem("UUID58")}"; style="background: #51AED3; border: 15px solid #51AED3; padding: 0 10px;color: #ffffff; font-family: sans-serif; font-size: 13px; line-height: 1.1; text-align: center; text-decoration: none; display: block; border-radius: 3px; font-weight: bold;" class="button-a"> 
                                                        <!--[if mso]>&nbsp;&nbsp;&nbsp;&nbsp;<![endif]-->SOLICITAR SUSCRIPCIÓN AHORA<!--[if mso]>&nbsp;&nbsp;&nbsp;&nbsp;<![endif]--> 
                                                    
                                                        </a></td>
                                                    </tr>
                                                    </table>
                                                    
                                                    <!-- Button : END --></td>
                                                </tr>
                                            </table></td>
                                        </tr>
                                        <tr>
                                            <td style="padding: 20px 10px;width: 100%;font-size: 12px; font-family: sans-serif; mso-height-rule: exactly; line-height:18px; text-align: center; color: #888888;">
                                            <span class="mobile-link--footer">Recuerda contactarnos en cualquier momento si tienes dudas a ClikAuto Mobility 800-022-5425</span>
                                            <br>
                                            <br>
                                        </tr>
                            </table>
                            <!-- Email Body : END --> 
                            
                            
                            <!--[if (gte mso 9)|(IE)]>
                                </td>
                                </tr>
                                </table>
                                <![endif]--> 
                            </div>
                        </center></td>
                    </tr>
                    </table>
                    </body>
                    </html>
            `};

        axios.post("https://qasrv-notificaciones.autocom.mx/api/emailSend",mail, {
            headers: {
            Authorization: "Bearer " + sessionStorage.getItem("mailToken"),
            'Content-Type': 'application/json',
            }, 
            }).then((response) => {
                console.log('Mail --->', response.status);
            }).catch(error => {
                console.log('Algo salio mal mail--->',error);
            });
        },

        cargarInfoVehiculo(){
            this.vin= sessionStorage.getItem("vinUnidad");
            // console.log('Seminuevo');
                axios.get("https://pruebas.autocomcube.mx/ab/api/usedstock", { //QA
                //axios.get("https://autocomcube.mx/ab/api/usedstock", { //PRO        
                headers: {
                    Authorization: "Bearer " + sessionStorage.getItem("tokenStock"),
                    'Content-Type': 'application/json',
                },
                params: {vin: this.vin,},
                })
                .then((response) => {
                    this.dealer = response.data.usedstock[0].dealerShip;
                    this.formaData.Vehiculo.Marca = response.data.usedstock[0].brandDescription;
                    this.formaData.Vehiculo.Inventario = response.data.usedstock[0].id;
                    this.formaData.Vehiculo.Modelo = response.data.usedstock[0].trimDesciption;
                    this.formaData.Vehiculo.Year = response.data.usedstock[0].modelYear;
                    this.formaData.Vehiculo.Version = response.data.usedstock[0].bodyType;
                    this.autos = response.data.usedstock;
                }).catch(error => {
            console.log(error);
            });
        },

        uuidv4() {
            const uuid = ([1e7]+-1e3+-4e3+-8e3+-1e11).replace(/[018]/g, c =>
            (c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16));
            sessionStorage.setItem("uuidsus", uuid);
            return uuid;
        },

        tokenLatin(){
            let TknLatin = {apikey: "5VC3jwvcPWWBbfJXHwezCEj116LoHEoJF"};
            axios.post("https://autocom-dev.latinid-cloud.com.mx/API/GetToken", TknLatin)
            .then((response) => {this.tokenLatin = response.data.token;
                sessionStorage.setItem("tknLatinSus", response.data.token);
                this.latinId();
            });
        },

        latinId(){
               axios.post("https://autocom-dev.latinid-cloud.com.mx/API/CheckAPI/MobilityWeb/MakeApplicant", this.formaData, {
                   headers: {
                   Authorization: "Bearer " + sessionStorage.getItem("tknLatinSus"),
                   'Content-Type': 'application/json',
                   }
               }).then((response) => {this.rest = response.data.SolicitanteId;
               sessionStorage.setItem("SolicitanteID", this.rest);
               //console.log('Solicitante-->', this.rest);
               //console.log('ID session -->', sessionStorage.getItem("SolicitanteID"));              
               this.base58();
              });
        },

        base58(){
            this.rest;
            this.valor=+this.rest+`||`+sessionStorage.getItem("uuidsus");
            // console.log('Valor--->',this.valor);
             axios.get("https://financiamiento.autocom.mx/api/base58/"+this.valor).then((response) => {
             this.base58 = response.data;
            //  console.log("Base 58-->", this.base58);
             sessionStorage.setItem("UUID58", this.base58);
             this.cotizar();
             });
        },

        formatPrice(value) {
            let val = (value/1).toFixed(0).replace('.', '.')
            return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
        },

    },

  created() {
      this.cargarInfoVehiculo();
      this.tokenMail();
   },

     computed: {
      validaRfc() {
        return this.formaData.RFC.length < 14 && this.formaData.RFC.length > 12 && this.formaData.RFC.length != '' ? true: false
      },

      validaTel() {
        return this.formaData.Telefono.length < 11 && this.formaData.Telefono.length > 9 && this.formaData.Telefono.length != '' ? true: false
      },

      validaCp() {
        return this.formaData.Domicilio.CodigoPostal.length < 6 && this.formaData.Domicilio.CodigoPostal.length > 4 && this.formaData.Domicilio.CodigoPostal.length != '' ? true: false
      },

      validaNombre() {
        return this.formaData.Nombre.length < 27 && this.formaData.Nombre.length > 0 && this.formaData.Nombre.length != '' ? true: false
      },

      validaApaterno() {
        return this.formaData.ApellidoPaterno.length < 27 && this.formaData.ApellidoPaterno.length > 0 && this.formaData.ApellidoPaterno.length != '' ? true: false
      },

      validaAmaterno() {
        return this.formaData.ApellidoMaterno.length < 27 && this.formaData.ApellidoMaterno.length > 0 && this.formaData.ApellidoMaterno.length != '' ? true: false
      },

      validaCalle() {
        return this.formaData.Domicilio.Calle.length < 41 && this.formaData.Domicilio.Calle.length > 0 && this.formaData.Domicilio.Calle.length != '' ? true: false
      },
      validaEstado() {
        return this.formaData.Domicilio.Estado.length < 41 && this.formaData.Domicilio.Estado.length > 0 && this.formaData.Domicilio.Estado.length != '' ? true: false
      },
      validaCiudad() {
        return this.Ciudad.length < 41 && this.Ciudad.length > 0 && this.Ciudad.length != '' ? true: false
      },
      validaMunicipio() {
        return this.formaData.Domicilio.Municipio.length < 41 && this.formaData.Domicilio.Municipio.length > 0 && this.formaData.Domicilio.Municipio.length != '' ? true: false
      },
      validaColonia() {
        return this.formaData.Domicilio.Colonia.length < 41 && this.formaData.Domicilio.Colonia.length > 0  && this.formaData.Domicilio.Colonia.length != '' ? true: false
      },
    }
  }
</script>

<style>

</style>